import React from "react";

const YoutubeHomePromo = ({ link }) => {
  return (
    <iframe
      width="560"
      height="315"
      src={link || "https://www.youtube.com/embed/ubGjT1_5S9I?rel=0"}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
  );
};

export default YoutubeHomePromo;
